import React from 'react';
import { connect } from 'react-redux';
import { path } from 'ramda';
import RoundedRectangleButton from 'src/components/RoundedRectangleButton';
import ConstituentCard from 'src/ConnectedComponents/ConstituentCard';
import Tooltip from 'src/components/Tooltip';

import { getFirstAuthOrganizationName } from 'src/redux/authOrganizations/authOrganization.selector';
import { getAuthUsers, getCurrentAuthUser } from 'src/redux/authUsers/authUser.selector';
import { requestUpdateAuthUser, requestCreateAuthUser } from 'src/redux/authUsers/authUser.action';
import { requestUpdateUserFundraiser } from 'src/redux/fundraisers/fundraiser.action';

import styles from './index.css';
import RemoveFundraiserModal from 'src/ConnectedComponents/RemoveFundraiserModal';
import { requestUpdateAssignment } from 'src/redux/donors/donor.action';
import { HyperLink, Paragraph } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

class FundraiserCard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
		};
	}

	handleFundraiserSelection = async () => {
		const userResponse = await this.props.requestUpdateAuthUser(
			this.props.currentAuthUser._id,
			{
				bb_id: this.props.fundraiser.bb_id,
				setup_state: 'complete',
			},
		);
		this.props.requestUpdateUserFundraiser(this.props.fundraiser._id, {
			// at least for today, team name always equals org name
			teams: userResponse.payload.organization,
		});
	};

	inviteUserToWisely = fundraiser => async () => {
		const { first, last, name, bb_id, email, teams } = fundraiser;
		await this.props.requestCreateAuthUser({
			fullname: name || [first, last].filter(str => str !== undefined).join(' '),
			email: email.address,
			...(bb_id && teams && teams.length > 0 ? { setup_state: 'complete', bb_id } : {}),
			// we're not really using this field at the moment and it's mostly "member"
			role: 'member',
			organization: this.props.organizationName,
			skip_password: true,
			active: true,
			email_confirmed: true,
		});
	};

	removeOnly = () => {
		this.showModal(false);
		if (this.props.onClick) {
			this.props.onClick();
		} else {
			this.handleFundraiserSelection();
		}
	};

	removeAndUnassign = async () => {
		const endDate = new Date();
		endDate.setDate(endDate.getDate() - 1);
		// When unassigning, user technically wants to make the assignment end before today.
		await this.props.requestUpdateAssignment(this.props.fundraiser._id, null, { end: endDate });

		this.removeOnly();
	};

	showModal = showModal => {
		this.setState({ showModal });
	};

	render() {
		const { fundraiser, isMe, authUsers, showInviteToWisely } = this.props;
		const fundraiserEmail = path(['email', 'address'], fundraiser);
		const hasBasicInfo = fundraiser.name && fundraiserEmail;
		const hasWiselyAccount =
			authUsers.find(
				user =>
					(user.bb_id && fundraiser.bb_id && user.bb_id === fundraiser.bb_id) ||
					(user.fullname && fundraiser.name && user.fullname === fundraiser.name) ||
					(user.email && fundraiserEmail && user.email === fundraiserEmail),
			) !== undefined;
		const eligibleForWiselyAccount = hasBasicInfo && !isMe && !hasWiselyAccount;

		return (
			<div className={styles.CardLayout}>
				<div className={styles.FundraiserDataLayout}>
					<ConstituentCard
						constituent={fundraiser}
						showTooltip={false}
						linkName={this.props.linkName}
						showLabel={false}
					/>
				</div>
				<div className={styles.ButtonLayout}>
					<RoundedRectangleButton
						padding="5px 10px"
						fontWeight="700"
						display="flex"
						justifyContent="center"
						marginTop="10px"
						marginBottom="10px"
						marginRight="5px"
						maxHeight="35px"
						disabled={this.props.buttonDisabled}
						disabledBackgroundColor={'grey'}
						pointerEvents={this.props.buttonDisabled ? 'none' : 'auto'}
						onClick={
							this.props.showModalOnClick &&
							this.props.fundraiser.portfolio_count !== 0
								? () => this.showModal(true)
								: this.props.onClick || this.handleFundraiserSelection
						}
						width={this.props.buttonWidth || '85px'}
						{...(this.props.backgroundColor
							? { backgroundColor: this.props.backgroundColor }
							: {})}
					>
						{this.props.message || "That's me!"}
					</RoundedRectangleButton>
					{isMe && (
						<Tooltip
							content={
								<Paragraph fontSize={theme.fontSizes[4]}>
									Not you?{' '}
									<HyperLink href="mailto:hello@fundraisewisely.com">
										Contact Support
									</HyperLink>{' '}
									and we'll <br />
									be happy to help!
								</Paragraph>
							}
							spanStyle={{ display: 'flex', alignItems: 'center' }}
						/>
					)}
					{showInviteToWisely && eligibleForWiselyAccount && (
						<RoundedRectangleButton
							padding="5px 10px"
							fontWeight="700"
							display="flex"
							justifyContent="center"
							maxHeight="35px"
							onClick={this.inviteUserToWisely(fundraiser)}
						>
							Invite to Wisely
						</RoundedRectangleButton>
					)}
				</div>
				{this.state.showModal ? (
					<RemoveFundraiserModal
						fundraiser={this.props.fundraiser}
						onClose={() => this.showModal(false)}
						removeOnly={this.removeOnly}
						removeAndUnassign={this.removeAndUnassign}
					/>
				) : null}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	authUsers: getAuthUsers(state),
	currentAuthUser: getCurrentAuthUser(state),
	organizationName: getFirstAuthOrganizationName(state),
});

const actions = {
	requestUpdateUserFundraiser,
	requestUpdateAuthUser,
	requestCreateAuthUser,
	requestUpdateAssignment,
};

export default FundraiserCard = connect(mapStateToProps, actions)(FundraiserCard);



// WEBPACK FOOTER //
// ./src/ConnectedComponents/FundraiserCard/index.js